module.exports = __webpack_public_path__ + "static/media/09.e08c2c22.jpg";